import objectPath from 'object-path';
import Vue from 'vue';
import axios from './axios';

Vue.use({
  install(Vue, options) {
    Vue.prototype.$path = objectPath.withInheritedProps;

    Vue.prototype.$redirectTimeout = 2500;

    Vue.prototype.$tableSortRoutine = (a, b, key) => {
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else if(typeof a[key] === 'object' && a.hasOwnProperty('name')) {
        return String(a[key].name).localeCompare(String(b[key].name), undefined, {numeric: true});
      } else if(typeof a[key] === 'object' && a.hasOwnProperty('title')) {
        return String(a[key].title).localeCompare(String(b[key].title), undefined, {numeric: true});
      } else {
        return String(a[key]).localeCompare(String(b[key]), undefined, {numeric: true});
      }
    };

    /**
     *
     * @param {File} file
     * @param data
     * @param {Function|object} config
     */
    Vue.prototype.$uploadSingleFile = function (file, data = {}, config) {
      const formData = new FormData();

      // Append the file and additional data
      formData.append('file', file);
      Object.entries(data).forEach(([key, value]) => formData.append(key, value));

      return axios.post('/upload', formData, typeof config === 'function' ? { onUploadProgress: config } : config);
    };

    Vue.prototype.$refreshFeatures = function () {
      this.$root.refreshFeatures();
    };

    Vue.prototype.$hasFeature = function (feature) {
      return this.$root.enabledFeatures.includes(feature);
    };
  },
});
